module.exports = __webpack_public_path__ + "img/full-link.e4c5c908.png";